import { UsersListPage } from './UsersListPage';

export function BlacklistPage() {
  return <UsersListPage pageTitle="黑名单" initialStatus="banned" />;
}
